/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Action constants types.
 */
const PREFIX = 'despachos';
export const UPDATE_VALUE = `${PREFIX}_value_updated`;
export const FETCH_DATA = `${PREFIX}_fetch_data`;
export const FETCHING = `${PREFIX}_fetching`;
export const FETCH_COMPLETE = `${PREFIX}_fetch_complete`;
export const NOTIFY = `${PREFIX}_notify`;



// WEBPACK FOOTER //
// ./containers/despachos/types.js